import { createSlice } from "@reduxjs/toolkit";
import { deleteRoleAPI } from "../../api/role";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteRoleSlice = createSlice({
  name: "deleteRole",
  initialState: data,
  reducers: {
   deleteRoleSlice(state) {
      state.isLoading = true;
    },
   deleteRoleSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteRoleSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteRoleSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteRoleHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteRoleAction.deleteRoleSlice());
    const response: any = await deleteRoleAPI(id);
    
    dispatch(deleteRoleAction.deleteRoleSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteRoleAction.deleteRoleSliceFailure(e?.response?.data));
  }
};
export default deleteRoleSlice.reducer;
export const deleteRoleAction = deleteRoleSlice.actions;
